import React, { Component } from "react";
import { connect } from "react-redux";
import CreateNewDialog from "./badge-designer-addedit";
import LocaleStrings from "Languages";

class BadgeDesignHeader extends Component {
  constructor(props) {
    super(props);
  }

  additionCallback = () => {
    this.props.finishOperationsCallback();
  };

  /**
   * Badge search by input
   */
  onBadgeSearch = (event) => {
    var searchText = event.target.value;

    //let pageNumber = 1;
    this.props.setSearch(searchText);
  };

  /**
   * Short by Name [Badge]
   */
  sortByBadgeFilter = (e) => {
    e.preventDefault();
    //var sortByCategory = e.target.value;
    var sortByVale = e.target.value;

    if (sortByVale == "all") {
    } else {
    }

    this.props.setSortByField(sortByVale);
    this.props.setSearch(""); // Initialize as blank

    //this.alphabetsFun("All");
  };

  render() {
    let { search, sortByField, isBadgeDesignModalOpen } = this.props;

    // Creating shortable object
    var shortByObject = [
      { label: "Short by : All", value: "all" },
      { label: "Short by : Name", value: "Name" },
    ];

    return (
      <div className="content-header-bar">
        {/* `Main page header [Short by / Search / Create] ` */}
        <div className="pull-left h-100 vertical-align-center widthusers-tab">
          {/* Short by Name [Filter] */}
          <div>
            {/*
              For now hide
             <select
              className="dropdown-height-border p-10"
              onChange={this.sortByBadgeFilter}
              value={sortByField}
            >
              {shortByObject.map((object, index) => {
                return (
                  <option key={`${object.value}-${index}`} value={object.value}>
                    {object.label}
                  </option>
                );
              })}
            </select> */}
          </div>
        </div>
        <div className="pull-right h-100 vertical-align-center">
          <ul className="header-buttons">
            <li className="users-search-input widthusers-tab">
              <input
                className="form-control mapsearch"
                placeholder={LocaleStrings.button_search}
                type="text"
                value={search}
                onChange={this.onBadgeSearch}
              />
            </li>
            <li>
              {/* Add / edit [+ Create New] */}
              <CreateNewDialog
                history={this.props.history}
                finishOperationsCallback={this.additionCallback}
              />
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    isBadgeDesignModalOpen: state.isBadgeDesignModalOpen,
  };
}

export default connect(mapStateToProps, {
  // all actions
})(BadgeDesignHeader);
